import { useContext } from 'react';
import authContext from './JWTAuthContext';

export const useAuth = () => {
    return useContext(authContext);
};
